import React, { useState, useEffect } from "react";
import {
  Container,
  Col,
  Row,
  InputGroup,
  Button,
  FormControl,
} from "react-bootstrap";
import { useParams } from "react-router-dom";
import { apiUrl } from "../commons/inFormTypes";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loaders from "../components/Loaders";
import { useNavigate } from "react-router-dom";
import { IPUrl } from "../commons/IPAddress";

function Follow() {
  const params = useParams();
  const [seenFile, setSeenFile] = useState([]);
  const [load, setLoad] = useState(false);
  const [FId, setFId] = useState(params.requestId);
  const [isSerch, setIsSerch] = useState(false);
  const userToken = localStorage.getItem("user_token");
  const navigate = useNavigate();


  useEffect(() => {
    const axios = require("axios");

    var data = new FormData();

    data.append("tracking_code", FId);
    setLoad(false);
    axios({
      method: "post",
      url: apiUrl + "followup",
      headers: {
        'Access-Control-Allow-Origin': "*",
        Accept: "application/json",
        Authorization: "Bearer " + userToken,
      },
      data: data,
    }).then((res) => {
      setLoad(true);
      if (res.data.success) {
        setSeenFile(res.data.result);
      } else {
      }
    });
  }, [isSerch]);

  const handleSearchHistoory = () => {
    if (isSerch) setIsSerch(false);
    else setIsSerch(true);
  };

  const editableHandler = (val) => {
    navigate(`/admin/service/follow/${val}`)
    // navigate(`/admin/service/${val}`)
  }

  //editable=true
  return (
    <div>
      <Container>
          <div className="test">
            <Row className="justify-content-center py-5">
              <Col xs={11} lg={7} className="text-center rgc-content-search">
                <Row className="rgc-item-follow justify-content-center">
                  <Col
                    xs={10}
                    lg={6}
                    className="text-center py-2"
                    for="requestCode"
                  >
                    <label for="requestCode">
                      لطفا کد پیگیری مورد نظر خود را وارد نمایید
                    </label>
                  </Col>

                  <Col xs={10} lg={5} className="text-center" for="requestCode">
                    <InputGroup className="mb-3 rgc-item-search-follow">
                      <Button
                        className="rgc-follow-search"
                        // variant="secondary"
                        id="button-addon1"
                        onClick={handleSearchHistoory}
                      ></Button>
                      <FormControl
                        className="form-control"
                        type="search"
                        id="requestCode"
                        placeholder="جستجو..."
                        aria-label="Search"
                        onChange={(event) => setFId(event.target.value)}
                      />
                    </InputGroup>
                  </Col>
                </Row>
              </Col>
              {seenFile.map((data, index) => {
                return (
                  <Col xs={11} lg={7} className="rgc-request my-2" for="requestCode">
                    <Row
                      key={index}
                      className="rgc-content-request px-0 px-md-5 py-3 g-0"
                    >
                      <Col xs={4} md={2}>
                        مرحله:
                      </Col>
                      <Col xs={8} md={10}>
                        {data.step}{data.current !== "" ? <span>(فعلی)</span> : ""}
                      </Col>
                      <hr />
                      <Col xs={4} md={2}>
                        تاریخ ورود:
                      </Col>
                      <Col xs={8} md={4}>
                        {data.date_in}
                      </Col>
                      <Col xs={4} md={2}>
                        تاریخ خروج:
                      </Col>
                      <Col xs={8} md={4}>
                        {data.date_out}
                      </Col>
                      <Col xs={4} md={2}>
                        بخش سازمانی :
                      </Col>
                      <Col xs={8} md={4}>
                        {data.group}
                      </Col>
                      <Col xs={4} md={2}>
                        اقدام کننده:
                      </Col>
                      <Col xs={8} md={4}>
                        {data.receiver}
                      </Col>
                      <Col xs={4} md={2}>
                        مدت زمان:
                      </Col>
                      <Col xs={8} md={4}>
                        {data.duration}
                      </Col>
                      <Col xs={4} md={2}>
                        وضعیت:
                      </Col>
                      <Col xs={8} md={4}>
                        {data.status}
                      </Col>
                      <Col xs={4} md={2}>
                        پاسخ ارجاع :
                      </Col>
                      <Col xs={8} md={10}>
                        {data.description}
                      </Col>
                      <Col xs={12} >
                        {/* service/edit/id?token=token */}
                        {data.editable ?
                         <Button  style={{color: "#ffffff"}} className="float-start rgc-follow-btn m-2"
                         onClick={() => editableHandler(data.id)}
                        > پیگیری و ارسال اطلاعات جدید  </Button>
                          : 
                          ""}
                      </Col>
                    </Row>

                  </Col>
                );
              })}
            </Row>
          </div>
      </Container>
      <div className="rgc-toast">
        <ToastContainer autoClose={3000} />
      </div>
      <Loaders loads={load} />
    </div>
  );
}

export default Follow;
